"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const color_const_1 = __importDefault(require("../choices/color.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const timing_const_1 = __importDefault(require("../choices/timing.const"));
const slideOut = {
    splitterSize: size_const_1.default.default,
    splitterCursor: 'col-resize',
    animationSpeed: timing_const_1.default.fast,
    background: color_const_1.default.white,
    boxShadowColor: '#000',
    boxShadowOpacity: 0.25,
    boxShadowSize: size_const_1.default.shadowMedium,
};
exports.default = slideOut;
